import { Box, Flex, Text } from "@chakra-ui/react";
import { useState } from "react";
import MyDiv from "./myleadViewDrawer.style";
import { ILead } from "../../LeadPool/model";


interface Props {
  lead: ILead | null;
}

const MyleadViewDrawer = ({ lead }: Props) => {

  const [revealedField, setRevealedField] = useState<string | null>(null);

  const toggleReveal = (field: string) => {
    setRevealedField(prev => (prev === field ? null : field));
  };

  const maskText = (text?: string) => {
    if (!text) return "";
    return "*".repeat(text.length);
  };

  if (!lead) return null;

  return (
    <MyDiv>

    

      <Box className="lead_table">

        {/* HEADER */}
        <Flex className="table_header">
          <Text className="col_field">Field</Text>
          <Text className="col_value">Value</Text>
        </Flex>

        {/* COMPANY */}
        <Flex className="table_row">
          <Text className="col_field">Company Name</Text>

          <Text className="col_value" cursor="pointer"  onClick={() => toggleReveal("companyName")}>
            {revealedField === "companyName"
              ? lead.companyName
              : maskText(lead.companyName)}

            
          </Text>
        </Flex>

        {/* INDUSTRY */}
        <Flex className="table_row">
          <Text className="col_field">Industry</Text>

          <Text className="col_value" cursor="pointer"   onClick={() => toggleReveal("industry")}>
            {revealedField === "industry"
              ? lead.industry
              : maskText(lead.industry)}

           
          </Text>
        </Flex>

        {/* WEBSITE */}
        <Flex className="table_row">
          <Text className="col_field">Website</Text>

          <Text className="col_value" cursor="pointer" onClick={() => toggleReveal("website")}>
            {revealedField === "website"
              ? lead.website
              : maskText(lead.website)}

           
          </Text>
        </Flex>

        {/* CONTACT */}
        <Flex className="table_row">
          <Text className="col_field">Contact Number</Text>

          <Text className="col_value" cursor="pointer" onClick={() => toggleReveal("contact")}>
            {revealedField === "contact"
              ? lead.contact
              : maskText(lead.contact)}

           
          </Text>
        </Flex>

        {/* EMAIL */}
        <Flex className="table_row">
          <Text className="col_field">Email</Text>

          <Text className="col_value" cursor="pointer"  onClick={() => toggleReveal("email")}>
            {revealedField === "email"
              ? lead.email
              : maskText(lead.email)}

          
          </Text>
        </Flex>

      </Box>

    </MyDiv>
  );
};

export default MyleadViewDrawer;